import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M8.417 4.484 3.582 10.34a.833.833 0 0 0 .113 1.173l.456.377-1.822 2.206a.492.492 0 0 0 .76.627l1.82-2.207.455.376a.833.833 0 0 0 1.173-.113l7.964-9.646a.833.833 0 0 0-.112-1.174L12.72.581a.833.833 0 0 0-1.172.112l-2.51 3.04-.002-.002-.62.75.002.003Zm3.862-2.322-2.085 2.526.64.53 2.086-2.526-.641-.53Zm-2.064 3.806-.64-.53-4.411 5.343.64.53 4.411-5.343Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function c(d, a) {
  return e(), t("svg", l, [...r]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
